import { render, staticRenderFns } from "./ConfigAutorizacionesPantalla.vue?vue&type=template&id=c1f400b6&"
import script from "./ConfigAutorizacionesPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConfigAutorizacionesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports